import mongoose from 'mongoose';

const partnerObj = {
  name: String,
  paymentExpire: Boolean,
  expires: Number,
  vertical: [ String ],
  host: String,
  port: Number,
  protocol: String,
  method: String,
  path: Object,
  voucher: Boolean,
  headers: { type: {}, default: {} },
  utm: {
    medium: String,
    campaign: String,
    source: String,
    content: String,
    term: String,
    customer: String
  },
  scope: {
    type: String,
    default: 'vertical'
  },
  platinum: {
    type: Boolean,
    default: false
  },
  hasHomepage: Boolean,
  partnerData: {
    type: {},
    default: {}
  },
  forcePageTitle: {
    type: {},
    default: {}
  },
  forcePageOgImage: {
    type: {},
    default: {}
  },
  partnerFilters: {
    type: {},
    default: {}
  },
  publicKey: {
    type: String
  },
  privateKey: {
    type: String
  },
  paymentFields: {
    type: {},
    default: {}
  },
  apiConfig: {
    type: {},
    default: {}
  },
  payment: {
    type: {},
    default: {}
  },
  partnerLogo: {
    type: String
  }
};

const schemaPartner = new mongoose.Schema<typeof partnerObj>(partnerObj);

export default schemaPartner;
